var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportStepWrapper"},[(_vm.reportId)?_c('PowerbiReport',{attrs:{"reportId":_vm.reportId,"workspaceId":_vm.workspaceId,"showLoading":false,"fitToWidth":_vm.shouldFitToWidth}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }